import { send } from '@actual-app/core/platform/client/connection';
import { q } from '@actual-app/core/shared/query';

import { aqlQuery } from '#queries/aqlQuery';

import type { DestinoPaga } from './nomina';

/**
 * Reparte una paga en el mes `mes` (`AAAA-MM`): suma a lo asignado de cada
 * categoría su parte. Lo de «Listo para asignar» se queda donde está. Los
 * destinos ya vienen recortados a lo que hay por asignar (`recortarReparto`).
 */
export async function repartirPaga(
  mes: string,
  destinos: readonly DestinoPaga[],
): Promise<void> {
  const categorias = destinos.filter(
    (d): d is Extract<DestinoPaga, { tipo: 'categoria' }> =>
      d.tipo === 'categoria',
  );
  if (categorias.length > 0) {
    const { data } = (await aqlQuery(
      q('zero_budgets')
        .filter({
          month: Number(mes.replace('-', '')),
          category: { $oneof: categorias.map(d => d.id) },
        })
        .select(['category', 'amount']),
    )) as { data: { category: string; amount: number | null }[] };
    const actual = new Map(data.map(f => [f.category, f.amount ?? 0]));
    await send('budget/budget-amounts', {
      month: mes,
      amounts: categorias.map(d => ({
        category: d.id,
        amount: (actual.get(d.id) ?? 0) + d.importe,
      })),
    });
  }
}
